var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "row" }, [
    _c("div", { staticClass: "col-12" }, [
      _c("div", { staticClass: "card bg-gradient-success p-1" }, [
        _c("div", { staticClass: "row align-items-center" }, [
          _vm._m(0),
          _vm._v(" "),
          _c("div", { staticClass: "col-12 col-md-7" }, [
            _c("h4", { staticClass: "text-white mb-0" }, [
              _vm._v(_vm._s(_vm.__("advertisement.headers.like"))),
            ]),
            _vm._v(" "),
            _c("p", { staticClass: "mb-0 font-small-3" }, [
              _vm._v(_vm._s(_vm.__("advertisement.headers.like_paragraph"))),
            ]),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "col-12 col-md-2" }, [
            _c(
              "a",
              { attrs: { href: "https://trybz.com.au", target: "_blank" } },
              [
                _c("button", { staticClass: "btn btn-white float-right" }, [
                  _vm._v(_vm._s(_vm.__("globals.find_out_more"))),
                ]),
              ]
            ),
          ]),
        ]),
      ]),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-12 col-md-3" }, [
      _c("img", {
        attrs: { src: "/images/trybz.png", height: "60", alt: "Logo" },
      }),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }